import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {css, styled} from 'styled-components'

export const StyledSecondaryDataContainer = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral[50]};
        padding: ${spacing * 1}px ${spacing * 2}px;
    `
)

export const StyledPrimaryDataContainer = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 1}px ${spacing * 6}px;
    `
)

export const StyledOtherCostsDataWrapper = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 1}px ${spacing * 4}px;
    `
)
